import { useState, useEffect, useRef } from 'react'
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Card, Col, Input, Row, Spin } from 'antd'
import { useTranslation } from 'react-i18next'
import AddOfficalHoliday from 'components/Modals/officalHolidayModal/AddOfficalHoliday'
import useGetOfficalHolidays from 'hooks/query/workSchedule/useGetOfficalHolidays'
import i18next from 'i18next'
import { isTechnical } from 'utils/helpers/check-roles'
import { UserModel } from 'models/users'
import { UserData } from 'utils/helpers/encrypt-decrypt-user'
import { officalHolidaysModel } from 'models/workSchedule'

interface TechsSetting {
  loadingMore: boolean
  data: officalHolidaysModel[]
  search: string
}
const { Search } = Input;
const OfficalHolidays = () => {
  const { t } = useTranslation()
  const [openAddOfficalHoliday, setOpenAddOfficalHoliday] = useState(false)
  const [techsSetting, setTechsSetting] = useState<TechsSetting>({
    loadingMore: false,
    data: [],
    search: "",
  })
  const [User, setUser] = useState<UserModel | null>(null);
  const sentinelRef = useRef<HTMLDivElement | null>(null)
  const Users = useGetOfficalHolidays({
    search: techsSetting.search,
  })

  useEffect(() => {
    setUser(UserData.Decrypt());
  }, [UserData.Decrypt]);

  useEffect(() => {
    if (Users.status === "success") {
      const allUsers = Users.data.pages.flatMap(p => p?.data || [])
      setTechsSetting(prev => ({
        ...prev,
        loadingMore: Users.hasNextPage === false,
        data: allUsers,
      }))
    }
  }, [Users.data?.pages])

  useEffect(() => {
    if (techsSetting.loadingMore) return
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        if (Users.hasNextPage) {
          Users.fetchNextPage()
        }
      }
    }, { rootMargin: '100px' })
    if (sentinelRef.current) observer.observe(sentinelRef.current)
    return () => {
      if (sentinelRef.current) observer.unobserve(sentinelRef.current)
    }
  }, [Users.hasNextPage])

  return (
    <div style={{ padding: "10px" }}>
      <div>
        <Button
          onClick={() => setOpenAddOfficalHoliday(true)}
          type="primary"
          icon={<PlusOutlined />}
          style={{ display: isTechnical(User?.role_id!) ? "none" : "block" }}
        >
          {t("add_offical_holiday")}
        </Button>
        <Search
          style={{
            marginTop: "10px",
            paddingLeft: "6px",
          }}
          placeholder={t("search_holiday")}
          value={techsSetting.search}
          onChange={e => {
            const value = e.target.value;
            setTechsSetting(prev => ({
              ...prev,
              search: value,
              data: [],
            }));
          }}
        />
        <Row gutter={[16,16]} style={{textAlign: i18next.language === "en" ? "left" : "right", marginTop: "10px"}}>
          {techsSetting.data.map((element, index) => (
              <Col key={index} md={8} sm={12} xs={24}>
                <Card title={element.date} variant="borderless">
                  {i18next.language === "en" ? element.translations.en : element.translations.ar}
                </Card>
              </Col>
          ))}
        </Row>
        <div ref={sentinelRef}></div>

        {(Users.isLoading || Users.isFetching) 
          ?       
            <div style={{ textAlign: "center", padding: "20px 0" }}>
              <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
            </div>
          : <></>  
        }

        <AddOfficalHoliday
          openAddOfficalHoliday={openAddOfficalHoliday}
          setOpenAddOfficalHoliday={setOpenAddOfficalHoliday}
        />
      </div>
    </div>
  )
}

export default OfficalHolidays
